import { useFlow } from '@router/stackflow';
import { useEffect } from 'react';

function usePermission() {
    const { push } = useFlow();
    useEffect(() => {
        if (localStorage.getItem('permissionAsked') !== 'true') {
            push('PermissionBottomSheet', {});
        }
    }, []);
}

export default usePermission;
